import { SCA_COOKIE } from '@/configs/constants';
import Cookies from './cookie';

export const getProductURL = (materialId: string, slug?: string, isSCAClient?: boolean) => {
  if (!materialId) return '#';

  if (isSCAClient) return `/seller/dp/${materialId}/${slug ?? ''}`;
  return `/dp/${materialId}/${slug ?? ''}`;
};

export const getCategoryURL = (categoryId?: string, isSCAClient?: boolean) => {
  if (isSCAClient) {
    return `/seller/c/${categoryId}`;
  }
  return `/c/${categoryId}`;
};

export const getStoreURL = (storeId?: string) => `/s/${storeId}`;

export const getSubCategoryURL = (
  categoryId?: string,
  subCategoryId?: string,
  isSCAClient?: boolean,
) =>
  isSCAClient ? `/seller/c/${categoryId}/${subCategoryId}` : `/c/${categoryId}/${subCategoryId}`;

export const getSearchURL = (searchKey: string, isSCAClient?: boolean) =>
  isSCAClient ? `/seller/search?q=${searchKey}` : `/search?q=${searchKey}`;

export const getOrderDetailURL = (orderItemId: string) => `/ecom/order/${orderItemId}`;
export const getBlogCategoryURL = (categoryId: string) => {
  if (categoryId === 'All') return '/blog';
  return `/blog/category/${categoryId}`;
};

export const getBlogURL = (blogId: string) => `/blog/${blogId}`;

export const getAuthorizedCenterURL = (cityId: string, pincode: string, id: number) =>
  `/authorized-center/${cityId}-${pincode}/${id}`;

export const getURLWithQueryParams = (
  endpoint: string,
  queryParams?: Record<string, any>,
): string => {
  if (!queryParams || !Object.keys(queryParams).length) return endpoint;

  const queryString = Object.entries(queryParams)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return `${endpoint}${endpoint.includes('?') ? '&' : '?'}${queryString}`;
};

export const getAssetDetailURL = (assetId: string) => `/amc/my-device/${assetId}`;

export const getAssetServiceBookingURL = (assetId: string) => `/services/${assetId}/book`;
export const getServiceTrackingURL = (assetId: string, reqId: string) =>
  `/statusTracking?assetid=${assetId}&reqId=${reqId}`;

export const getSellerCategoryUrl = (categoryId?: string) => `/seller/c/${categoryId}`;
